<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="add"
                            :loading="dataForm.addLoading" v-if="page.isNew">Salvar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataForm.updateLoading" v-if="!page.isNew">Atualizar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="generatePassword"
                            :loading="dataForm.updateLoading" v-if="!page.isNew">Gerar acesso</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/solicitantes">Voltar</v-btn>
                    </div>
                    <!-- <div class="button-group">
                        <v-btn type="button" elevation="0" color="primary" @click="add"
                            :loading="dataset.loading">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/passageiros">Voltar</v-btn>
                    </div> -->
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Nome" v-model="dataset.data.name" required
                                                :rules="[$rules.required]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense type="text" label="E-mail" v-model="dataset.data.email"
                                                required outlined hide-details="auto"
                                                :rules="[$rules.required, $rules.email]">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-select dense id="profile" :items="dataset.adminProfiles" label="Cargo"
                                                v-model="dataset.data.profile" item-value="id" required
                                                :rules="[$rules.required]" item-text="name" outlined
                                                hide-details="auto">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-autocomplete dense :items="dataset.customers" label="Empresas"
                                                :loading="dataset.customerLoading" required
                                                :search-input.sync="searchCustomer" multiple
                                                :rules="[rules.requiredArray]" v-model="dataset.data.customers"
                                                item-value="id" item-text="name" outlined cache-items
                                                hide-details="auto" no-data-text="Nenhuma empresa encontrada"
                                                return-object deletable-chips @change="clearSearchField"
                                                :filter="() => true">
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="dataset.data.profile !== 1">
                                        <v-col cols="12" md="6">
                                            <v-autocomplete dense :items="dataset.costCenters" label="Centros de custo"
                                                :loading="dataset.costCenterLoading"
                                                :search-input.sync="searchCostCenter" multiple v-model="dataset.data.cost_centers"
                                                item-value="id" item-text="code" outlined cache-items
                                                hide-details="auto" no-data-text="Nenhum centro de custo encontrado"
                                                return-object deletable-chips @change="clearSearchField"
                                                :filter="() => true">
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <!-- <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Centro de custo</v-card-title>
                                <v-card-text v-if="dataset.data.cost_centers && dataset.data.cost_centers.length">
                                    <v-row v-for="(item, index) in dataset.data.cost_centers" :key="index"
                                        align="center">
                                        <v-col cols="12" sm="4">
                                            <v-select dense id="costCenter" :items="dataset.costCenters"
                                                label="Centro de custo" v-model="item.cost_center_id" item-value="id"
                                                required :rules="[$rules.required]" item-text="name" outlined
                                                hide-details="auto">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" sm="2">
                                            <v-tooltip bottom>
                                                <template #activator="{ on }">
                                                    <v-icon v-on="on" @click="deleteCostCenter(item)" size="large">
                                                        mdi-delete
                                                    </v-icon>
                                                </template>
<span>Remover centro de custo</span>
</v-tooltip>
</v-col>
</v-row>
</v-card-text>
<v-card-text v-else>
    Nenhum centro de custo adicionado
</v-card-text>
<v-card-text>
    <v-btn id="addCostCenter" color="primary" dark small @click="addCostCenter" elevation="2">Adicionar</v-btn>
</v-card-text>
</v-card>
</v-col>
</v-row>
</v-col>
</v-row> -->
        </v-form>

    </v-container>
</template>

<script>
import axios from "axios"

import debounce from 'lodash/debounce'

import adminProfiles from '@/common/data/admin-profiles.data'

export default {
    name: "RequesterDetails",

    data: () => ({
        page: {
            title: "",
            isNew: false
        },
        dataset: {
            data: {
                cost_centers: [],
                customers: []
            },
            breadcrumbItems: [],
            customers: [],
            addresses: [],
            costCenters: [],
            adminProfiles: adminProfiles,
            loading: false,
            addressLoading: false,
            customerLoading: false,
            costCenterLoading: false
        },
        rules: {
            requiredArray: v => (v && v.length > 0) || 'Selecione ao menos uma empresa'
        },
        dataForm: {
            validForm: true,
        },
        searchAddress: null,
        searchCustomer: '',
        searchCostCenter: ''
    }),

    created() {
        this.loadData()
    },

    watch: {
        searchCustomer(val) {
            this.loadCustomers(val);
        },
        searchCostCenter(val) {
            this.loadCostCenters(val);
        },
    },

    methods: {
        goBack() {
            this.$router.replace("/solicitantes");
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();

            await this.load();
            await this.loadCostCenters();
        },

        clearSearchField() {
            this.searchPassenger = '';
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = this.page.isNew ? "Novo solicitante" : "Detalhes do solicitante";
        },


        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Listagem de solicitantes",
                disabled: false,
                to: "/solicitantes",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.isNew ? "Incluir solicitante" : "Detalhes do solicitante",
                disabled: true,
                exact: true,
            });
        },

        async load() {
            if (this.page.isNew) return;

            this.dataset.loading = true

            try {
                const result = await axios.get(`/api/v2/requesters/${this.$route.params.id}`);

                this.dataset.data = result.data.content
                this.dataset.data.customers = result.data.content.customers.map((x) => x.customer);
                this.dataset.data.cost_centers = result.data.content.cost_centers.map((x) => x.cost_center);

                console.log('customers ', this.dataset.data.customers)

                this.dataset.customers = this.dataset.data.customers
                this.dataset.costCenters = this.dataset.data.cost_centers

            } catch (error) {
                console.log('error ', error.toString())
                this.$dialog.notify.error('Ocorreu um erro ao encontrar as informações do solicitante, tente novamente!', {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        loadCustomers: debounce(async function (filter) {

            if (!filter) return;

            this.dataset.customerLoading = true

            try {
                const result = await axios.get(`/api/v2/customers`, { params: { limit: 10, search: { name: filter } } });

                this.$set(this.dataset, 'customers', result.data.content.data)

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.customerLoading = false;
            }
        }, 1000),

        loadCostCenters: debounce(async function (filter) {

            if (!filter) return;

            this.dataset.costCenterLoading = true

            try {
                const result = await axios.get(`/api/v2/cost-centers`, { params: { limit: 10, search: { code: filter, customers: this.dataset.data.customers.map((x) => x.id) } } });
                this.dataset.costCenters = result.data.content.data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.costCenterLoading = false;
            }
        }, 1000),

        // async loadCostCenters() {
        //     this.dataset.loading = true

        //     try {
        //         const result = await axios.get(`/api/v2/requesters/cost-centers`);

        //         this.dataset.costCenters = result.data.content

        //     } catch (error) {
        //         this.$dialog.notify.error('Ocorreu um erro ao encontrar as informações dos centros de custos, tente novamente!', {
        //             position: 'top-right',
        //             timeout: 2000
        //         })
        //     } finally {
        //         this.dataset.loading = false;
        //     }
        // },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir o solicitante?',
                title: 'Incluir solicitante',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post('/api/v2/requesters', payload);

                this.$dialog.notify.info("Solicitante salvo com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }

        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar os dados do solicitante?',
                title: 'Atualizar solicitante',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/v2/requesters/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Solicitante atualizado com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        async generatePassword() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja gerar um novo acesso para o solicitante?',
                title: 'Atualizar solicitante',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post(`/api/v2/requesters/generate-password/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Acesso gerado com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        buildPayload() {

            let data = {
                name: this.dataset.data.name,
                email: this.dataset.data.email,
                profile: this.dataset.data.profile,
                cost_centers: this.dataset.data.cost_centers.map((x) => x.id),
                customers: this.dataset.data.customers.map((x) => x.id)
            }


            return data;
        },

        addCostCenter() {
            this.dataset.data.cost_centers.push({ cost_center_id: null })
        },

        deleteCostCenter(index) {
            this.dataset.data.cost_centers.splice(index, 1);
        }

    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
</style>